import {styled} from '@linaria/react';
import {COLORS} from '../../../constants/colors';

export const dividerStyles = `
  padding: 1.5rem 1rem;
  border-bottom: 1px solid ${COLORS.Grey3};
`;

export const Divider = styled.div<{noMargin?: boolean}>`
  border-top: 1px solid ${COLORS.Grey3};
  width: 100%;
  margin: ${props => (props.noMargin ? 0 : '1.5rem 0')};
`;
